//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      capture: ""
    };
  },

  computed: {
    cellClass: function() {
      return {
        "van-cell": true,
        "van-field": true,
        "van-cell--required": this.controlItem.IsRequired
      };
    }
  },
  created() {},
  methods: {}
};
